export default __webpack_public_path__ + "static/media/dragon-header2.6eca543b.png";